var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c(
        "article",
        { staticClass: "box" },
        [
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _c("p", { staticClass: "title" }, [
                _c("span", { staticClass: "has-badge-child-offset2" }, [
                  _vm._v("Documents"),
                ]),
                _vm.documentCount
                  ? _c("span", {
                      staticClass:
                        "has-badge-rounded has-badge-info has-badge-large",
                      attrs: { "data-badge": _vm.documentCount },
                    })
                  : _vm._e(),
                _c(
                  "a",
                  {
                    staticClass: "button is-secondary is-pulled-right",
                    on: {
                      click: function ($event) {
                        return _vm.toggleCategoryModal(true)
                      },
                    },
                  },
                  [_vm._m(0), _c("span", [_vm._v("Category")])]
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isLoading > 0,
                  expression: "isLoading > 0",
                },
              ],
              staticClass: "columns is-multiline",
            },
            [_vm._m(1)]
          ),
          _c("quote-attachment-category-modal", {
            attrs: { active: _vm.modalOpen },
            on: {
              cancel: function ($event) {
                return _vm.toggleCategoryModal(false)
              },
              "categories-changed": function ($event) {
                return _vm.getQuoteAttachmentCategories()
              },
            },
          }),
          _vm._l(_vm.categories, function (category) {
            return [
              _c("quote-attachment-category", {
                key: category.quoteAttachmentCategoryId,
                attrs: {
                  category: category,
                  "quote-id": _vm.value.quoteId,
                  attachments: category.attachments,
                  categories: _vm.categories,
                },
                on: {
                  "update:attachments": (e) => _vm.handleUpdateAttachments(e),
                  "image-uploaded": function ($event) {
                    return _vm.getQuoteAttachments()
                  },
                },
              }),
            ]
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-plus" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section" }, [
      _c("span", {
        staticClass: "is-loading-image has-text-grey has-text-centered",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }